/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_MvpInputs */

const en_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const ar_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const bn_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const de_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const es_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const fr_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const pt_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const zh_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const tr_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const ru_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const pl_svtag_mvp = /** @type {(inputs: Svtag_MvpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

/**
* | output |
* | --- |
* | "#MVP" |
*
* @param {Svtag_MvpInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_mvp = /** @type {((inputs?: Svtag_MvpInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_MvpInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_mvp(inputs)
	if (locale === "bn") return bn_svtag_mvp(inputs)
	if (locale === "de") return de_svtag_mvp(inputs)
	if (locale === "es") return es_svtag_mvp(inputs)
	if (locale === "fr") return fr_svtag_mvp(inputs)
	if (locale === "pt") return pt_svtag_mvp(inputs)
	if (locale === "zh") return zh_svtag_mvp(inputs)
	if (locale === "tr") return tr_svtag_mvp(inputs)
	if (locale === "ru") return ru_svtag_mvp(inputs)
	if (locale === "pl") return pl_svtag_mvp(inputs)
	return en_svtag_mvp(inputs)
});